import PropTypes from 'prop-types';
import React from 'react';

import IconButton from './IconButton';

const CloseButton = ({onClick}) => {
  return (
    <div className="CloseButton">
      <IconButton
        styleName={`IconButton--closeButton`}
        onClick={onClick}
      />
    </div>
  );
};

CloseButton.PropTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/components/CloseButton.js